import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
import CurrencyService from "../../../Services/QRCodeServices/CurrencyService/CurrencyService";

const AddCurrency = ({ isOpen, toggleModal, refreshData }) => {
  // Initial values for the form
  const initialValues = {
    title: "",
    currencyCode: "",
    description: "",
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    currencyCode: Yup.string()
      .required("Currency Code is required")
      .max(3, "Currency Code must be 3 characters"),
    description: Yup.string().required("Description is required"),
  });

  const handleSubmit = async (values) => {
    try {
      const response = await CurrencyService.create(values);
      toast.success("Currency added successfully");
      console.log("Response from server: ", response);
      toggleModal();
      refreshData();
    } catch (error) {
      console.error("Error during submission: ", error);
      toast.error("An error occurred during submission. Please try again.");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>Add Currency</ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="title">Title</Label>
                    <Field
                      name="title"
                      type="text"
                      placeholder="Enter Title"
                      className="form-control"
                      id="title"
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="text-danger"
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="currencyCode">Currency Code</Label>
                    <Field
                      name="currencyCode"
                      type="text"
                      placeholder="Enter Currency Code (e.g., NRS)"
                      className="form-control"
                      id="currencyCode"
                    />
                    <ErrorMessage
                      name="currencyCode"
                      component="div"
                      className="text-danger"
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="description">Description</Label>
                    <Field
                      name="description"
                      as="textarea"
                      placeholder="Enter Description"
                      className="form-control"
                      id="description"
                    />
                    <ErrorMessage
                      name="description"
                      component="div"
                      className="text-danger"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <ModalFooter>
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default AddCurrency;
